import { RouteProps } from 'src/router';
import {
  NucleusAuthenticate,
  NucleusSSO,
  OmniverseHome,
  OmniverseAppInfo,
  OmniverseAppStream,
  OmniverseAppStreamList,
  OmniverseUserSessionList,
} from './pages';

export const omniverseRoutes: RouteProps[] = [
  {
    index: true,
    component: OmniverseHome,
    meta: {
      title: 'Omniverse',
    },
  },
  {
    path: 'nucleus/authenticate',
    component: NucleusAuthenticate,
    meta: {
      title: 'Nucleus Authenticate',
    },
  },
  {
    path: 'nucleus/sso/:state',
    component: NucleusSSO,
    meta: {
      title: 'Nucleus SSO',
    },
  },
  {
    path: 'sessions',
    component: OmniverseUserSessionList,
    meta: {
      title: 'Sessions',
    },
  },
  {
    path: 'app/:appId',
    component: OmniverseAppInfo,
    meta: {
      title: 'App Info',
    },
  },
  {
    path: 'app/:appId/sessions',
    component: OmniverseAppStreamList,
    meta: {
      title: 'App Sessions',
    },
  },
  {
    path: 'app/:appId/sessions/:sessionId',
    component: OmniverseAppStream,
    meta: {
      title: 'Stream',
    },
  },
];
